import Cookies from "js-cookie";
import { CookiesKey } from "@/types/cookies";
import { v4 } from "uuid";
import * as Sentry from "@sentry/browser";

export const initSessionId = () => {
  let value = new URLSearchParams(window.location.search).get(
    CookiesKey.BROWSER_ID
  );
};
export const getSessionId = () => {
  // get browser id from landings
  const value = new URLSearchParams(window.location.search).get(
    CookiesKey.BROWSER_ID
  );

  // main case: if landings provide session id, we need to use it
  if (value) {
    // rewrite session id if previous time url value was empty or used fallback 2
    Cookies.set(CookiesKey.BROWSER_ID, value);

    return value;
  }

  // fallback 1: if something went wrong,  get session id from prev visit
  // or from parent landing cookies
  let cookieValue = Cookies.get(CookiesKey.BROWSER_ID);
  // let value = Cookies.get(CookiesKey.SESSION_ID);

  if (!cookieValue) {
    // fallback 2: if nothing found, generate new session id
    cookieValue = v4();
    Cookies.set(CookiesKey.BROWSER_ID, cookieValue);
  }

  return cookieValue;
};

export const getCheckInHeader = () => {
  if (window.location.pathname.startsWith("/check-in")) {
    return "true";
  }

  return undefined;
};

export const getAffiliateId = () => {
  let value = Cookies.get(CookiesKey.QUIZ_AFFILIATE_ID);

  return value;
};

export const getAffiliateSource = () => {
  let value = Cookies.get(CookiesKey.QUIZ_AFFILIATE_CMP);

  return value;
};

export const getEntrySource = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const value = searchParams.get("entry_source");

  return value;
};

export const getEntrySourceQueryParam = () => {
  const source = getEntrySource();

  return `entry_source=${source || "unknown"}`;
};

const headerPrefix = "x-quiz-aff";
const everflowClickIdHeader = `${headerPrefix}-Click-Id`;
const everflowSub2Header = `${headerPrefix}-sub2`;

// this headers used to analyze affiliates
// when quiz is last step of user journey
export const getCPLAffiliateHeaders = (): Record<
  string,
  string | undefined
> => {
  const mergedAffDataCookie =
    Cookies.get(CookiesKey.AFFILIATE_UTM_MERGED) ?? "{}";

  // if (!mergedAffDataCookie) {
  //   return {};
  // }

  const resObj: Record<string, string | undefined> = {};

  // might be problems with decoding, parsing
  try {
    const urlQueryParams = new URLSearchParams(window.location.search);

    const mergedDataParsed = JSON.parse(
      decodeURIComponent(mergedAffDataCookie)
    );

    Object.entries(mergedDataParsed).forEach(([key, value]) => {
      // don't want anything else in header
      if (typeof value === "string" || typeof value === "number") {
        resObj[`${headerPrefix}-${key?.replaceAll("_", "-")}`] = String(value);

        if (key === "_ef_transaction_id") {
          resObj[everflowClickIdHeader] = String(value);
        }
      }
    });

    if (!resObj[everflowClickIdHeader]) {
      resObj[everflowClickIdHeader] =
        urlQueryParams.get("_ef_transaction_id") ||
        Cookies.get(CookiesKey.QUIZ_EV_CLICK_ID) ||
        undefined;
    }

    if (!resObj[`${headerPrefix}-sub2`]) {
      resObj[`${headerPrefix}-sub2`] = urlQueryParams.get("sub2") || undefined;
    }

    return resObj;
  } catch (e) {
    console.error(e);
    Sentry.captureException(e);
    return {};
  }
};
